var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"share",on:{"click":_vm.close}},[_c('img',{attrs:{"src":"https://picbed.qunarzz.com/c046d5bc2ebb22b22853d5d10c0aef41.png","alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }